import { governmentAllocationEntriesKind } from '@/common/constants/governmentAllocationEntriesKind.constant';
import { PaymentModalityType } from '@/common/types/companies/companies.type'
import { GovernmentAllocationDetails } from '@/features/governmentAllocations/components/GovernmentAllocationDetails'
import { GovernmentAllocationMonthDetails } from '@/features/governmentAllocations/components/GovernmentAllocationMonthDetails'
import { governmentAllocationColumns } from '@/features/governmentAllocations/constants/governmentAllocationColumns.constant'
import { GovernmentAllocationData } from '@/features/governmentAllocations/types/governmentAllocation.type'
import { createElement, Dispatch, ReactElement, SetStateAction } from 'react'
import { governmentAllocationStatusStrategy } from '../pages/Show/constants/governmentAllocationStatus.constant';
import { formatDateRange } from '@/common/utils/formatters';
import { CompanyContractConsumptionControlledBy } from '@/features/company/types/contract.type';
import { AllocatedAndConsumedDetails } from '../types/companySummaryOfAllAllocatedAndConsumed.type';

export class GovernmentAllocationTransformer {
  static tableTransformer({
    governmentAllocations,
    paymentModality,
    year,
    controlledBy,
    setGovernmentAllocationIdToSearchSummaryInfo,
    summaryOfAllAllocatedAndConsumed,
  }: {
    governmentAllocations: GovernmentAllocationData[];
    paymentModality?: PaymentModalityType;
    year: number;
    controlledBy?: CompanyContractConsumptionControlledBy;
    setGovernmentAllocationIdToSearchSummaryInfo: Dispatch<SetStateAction<string>>,
    summaryOfAllAllocatedAndConsumed?: AllocatedAndConsumedDetails,
  }) {
    return () => {
      return governmentAllocations.map((governmentAllocation) => {
        const object: Record<string, ReactElement> = {}


        governmentAllocation.applicable_end_date = governmentAllocation.applicable_end_date.replace(/-/g, '/')
        governmentAllocation.applicable_start_date = governmentAllocation.applicable_start_date.replace(/-/g, '/')


        governmentAllocationColumns().forEach((column, index) => {
          object[column.value] = createElement(GovernmentAllocationMonthDetails, {
            governmentAllocation,
            year,
            month: index - 1,
          })
        })

        object.governmentAllocation = createElement(GovernmentAllocationDetails, {
          governmentAllocation,
          paymentModality,
          controlledBy,
          setGovernmentAllocationIdToSearchSummaryInfo,
          summaryOfAllAllocatedAndConsumed,
        })

        return object
      })
    }
  }

  static errorsTransformer() {
    return (errors: Record<string, string[]>) => {
      return Object.entries(errors).map(([key, value]) => {
        if (key.startsWith('product_categories_distributions.')) {
          key = '_base';
        }

        return {
          [key]: value.join(', ')
        };
      });
    };
  }

  static quickSearchModelTransformer() {
    return (governmentAllocations: GovernmentAllocationData[]) => {
      return governmentAllocations.map((governmentAllocation) => ({
        route: governmentAllocation.main_entry.status === 'completed'
          ? `/government-allocations/${governmentAllocation.id}`
          : `/government-allocations/${governmentAllocation.main_entry.id}/edit`,
        items: [
          ['Número', governmentAllocation.main_entry.office_number],
          ['Tipo', governmentAllocationEntriesKind[governmentAllocation.main_entry.kind as keyof typeof governmentAllocationEntriesKind]],
          ['Status', governmentAllocationStatusStrategy[governmentAllocation.status as keyof typeof governmentAllocationStatusStrategy]],
          ['Período', formatDateRange(new Date(`${governmentAllocation.applicable_start_date} `), new Date(`${governmentAllocation.applicable_end_date} `))],
          ['Filial', governmentAllocation.branch_display_name],
        ],
      }));
    };
  }
}
